export interface AiSummaryStage {
  stage: string;
  description?: string;
}

export interface AiSummaryNoteInput {
  /** Number of AI photos actually attached to the note. */
  photoCount: number;
  /** True when the AI auto-fill returned no usable stage suggestions. */
  aiFoundNothing: boolean;
  /** Stages the user is submitting, in display order. */
  stages: AiSummaryStage[];
}

/**
 * Compose the text of the AI auto-fill summary note. Never returns an empty
 * string, so the AI photos always have a note to land on.
 */
export const buildAiSummaryNoteText = ({
  photoCount,
  aiFoundNothing,
  stages,
}: AiSummaryNoteInput): string => {
  const photos = `${photoCount} photo${photoCount === 1 ? "" : "s"}`;
  const stageLines = stages.map(({ stage, description }) => {
    const desc = description?.trim();
    return desc ? `${stage}: ${desc}` : stage;
  });

  if (aiFoundNothing) {
    const header = `AI reviewed ${photos} and found no recon work needed.`;
    if (stageLines.length === 0) return header;
    return [`${header} Requests added manually:`, ...stageLines].join("\n\n");
  }

  if (stageLines.length === 0) {
    return `AI reviewed ${photos}. No recon requests were created.`;
  }
  return stageLines.join("\n\n");
};
